import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-filesystemprovider" id="module-storage-filesystemprovider"></a>
    <h1 {...{
      "id": "requireuxpstoragelocalfilesystem"
    }}>{`require('uxp').storage.localFileSystem`}</h1>
    <p>{`Provides access to files and folders on a file system. You'll typically not
instantiate this directly; instead you'll use an instance of one that has
already been created for you by UXP.`}</p>
    <p>{`These APIs work with UXP Manifest version v5 and above.`}</p>
    <a name="module-storage-filesystemprovider-isfilesystemprovider" id="module-storage-filesystemprovider-isfilesystemprovider"></a>
    <h2 {...{
      "id": "isfilesystemprovider--boolean"
    }}>{`isFileSystemProvider : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Indicates that this is a `}<inlineCode parentName="p">{`FileSystemProvider`}</inlineCode>{`. Useful for type-checking.`}</p>
    <a name="module-storage-filesystemprovider-supporteddomains" id="module-storage-filesystemprovider-supporteddomains"></a>
    <h2 {...{
      "id": "supporteddomains--arraysymbol"
    }}>{`supportedDomains : `}<inlineCode parentName="h2">{`Array<Symbol>`}</inlineCode></h2>
    <p>{`An array of the domains this file system supports. If the file system can
open a file picker to the user's `}<inlineCode parentName="p">{`documents`}</inlineCode>{` folder, for example, then `}<a parentName="p" {...{
        "href": "./domains#module-storage-domains-userdocuments"
      }}>{`userDocuments`}</a>{` will be in this list.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`if (fs.supportedDomains.contains(domains.userDocuments)) {
    console.log("We can open a picker to the user's documents.")
}
`}</code></pre>
    <a name="module-storage-filesystemprovider-getfileforopening" id="module-storage-filesystemprovider-getfileforopening"></a>
    <h2 {...{
      "id": "getfileforopeningoptions"
    }}>{`getFileForOpening(options)`}</h2>
    <p>{`Gets a file (or files) from the file system provider for the purpose of
opening them. Files are read-only.`}</p>
    <p>{`Multiple files can be returned if the `}<inlineCode parentName="p">{`allowMultiple`}</inlineCode>{` option`}<inlineCode parentName="p">{`is`}</inlineCode>{`true\`.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<File|Array<File>>`}</inlineCode>{` based on `}<inlineCode parentName="p">{`allowMultiple`}</inlineCode>{`. Return empty if no file was selected.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.initialDomain]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Symbol`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the preferred initial location of the file picker. If not defined, the most recently used domain from a file picker is used instead.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.types]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<string>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`[&#x27;.*&#x27;]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array of file types that the file open picker displays.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.initialLocation]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`File`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Folder`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the initial location of the file picker. You can pass an existing file or folder entry to suggest the picker to start at this location. If this is a file entry then the method will pick its parent folder as initial location. This will override initialDomain option.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.allowMultiple]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`if true, multiple files can be selected`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const folder = await fs.getFolder({initialDomain: domains.userDocuments});
const file = await fs.getFileForOpening({initialLocation: folder});
if (!file) {
    // no file selected
    return;
}
const text = await file.read();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const files = await fs.getFileForOpening({allowMultiple: true, types: fileTypes.images});
if (files.length === 0) {
    // no files selected
}
`}</code></pre>
    <a name="module-storage-filesystemprovider-getfileforsaving" id="module-storage-filesystemprovider-getfileforsaving"></a>
    <h2 {...{
      "id": "getfileforsavingsuggestedname-options"
    }}>{`getFileForSaving(suggestedName, options)`}</h2>
    <p>{`Gets a file reference suitable for read-write. Displays a file picker to select a location to "Save" the file.`}</p>
    <p>{`If the act of writing to the file would overwrite it, the file picker
will prompt the user to confirm before returning a result to you.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<File>`}</inlineCode>{` - returns the selected file, or `}<inlineCode parentName="p">{`null`}</inlineCode>{` if no file were selected.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`suggestedName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required when `}<inlineCode parentName="td">{`options.types`}</inlineCode>{` is not defined.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.initialDomain]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Symbol`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The preferred initial location of the file picker. If not defined, the most recently used domain from a file picker is used instead.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.types]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<string>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Allowed file extensions, with no "." prefix.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const file = await fs.getFileForSaving("output.txt", { types: [ "txt" ]});
if (!file) {
    // file picker was cancelled
    return;
}
await file.write("It was a dark and stormy night");
`}</code></pre>
    <a name="module-storage-filesystemprovider-getfolder" id="module-storage-filesystemprovider-getfolder"></a>
    <h2 {...{
      "id": "getfolderoptions"
    }}>{`getFolder(options)`}</h2>
    <p>{`Gets a folder from the file system via a folder picker dialog. The files
and folders within can be accessed via `}<a parentName="p" {...{
        "href": "./Folder#getentries"
      }}>{`Folder#getEntries`}</a>{`. Any
files within are read-write.`}</p>
    <p>{`If the user dismisses the picker, `}<inlineCode parentName="p">{`null`}</inlineCode>{` is returned instead.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Folder | null>`}</inlineCode>{` - the selected folder or `}<inlineCode parentName="p">{`null`}</inlineCode>{` if no folder is selected.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.initialDomain]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Symbol`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the preferred initial location of the file picker. If not defined, the most recently used domain from a file picker is used instead.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const folder = await fs.getFolder();
const myNovel = (await folder.getEntries()).filter(entry => entry.name.indexOf('novel') > 0);
const text = await myNovel.read();
`}</code></pre>
    <a name="module-storage-filesystemprovider-gettemporaryfolder" id="module-storage-filesystemprovider-gettemporaryfolder"></a>
    <h2 {...{
      "id": "gettemporaryfolder"
    }}>{`getTemporaryFolder()`}</h2>
    <p>{`Returns a temporary folder. The contents of the folder will be removed when
the extension is disposed.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Folder>`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const temp = await fs.getTemporaryFolder();
`}</code></pre>
    <a name="module-storage-filesystemprovider-getdatafolder" id="module-storage-filesystemprovider-getdatafolder"></a>
    <h2 {...{
      "id": "getdatafolder"
    }}>{`getDataFolder()`}</h2>
    <p>{`Returns a folder that can be used for extension's data storage without user interaction.
It is persistent across host-app version upgrades.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Folder>`}</inlineCode>{`  `}</p>
    <a name="module-storage-filesystemprovider-getpluginfolder" id="module-storage-filesystemprovider-getpluginfolder"></a>
    <h2 {...{
      "id": "getpluginfolder"
    }}>{`getPluginFolder()`}</h2>
    <p>{`Returns an plugin's folder – this folder and everything within it are read only.
This contains all the Plugin related packaged assets.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Folder>`}</inlineCode>{`  `}</p>
    <a name="module-storage-filesystemprovider-createentrywithurl" id="module-storage-filesystemprovider-createentrywithurl"></a>
    <h2 {...{
      "id": "createentrywithurlurl-options"
    }}>{`createEntryWithUrl(url, options)`}</h2>
    <p>{`Creates an entry for the given url and returns the appropriate instance.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<File|Folder>`}</inlineCode>{` the File or Folder object which is created for the given url`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if invalid file url format or value is passed.
if the parent folder of the file/folder to be created does not exist.
if a folder already exists at the url.
if a file already exists at the url and it is requested to create a folder.
if a file already exists at the url and the overwrite option is not set to true to create a file.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the url to create an Entry object. Note that file: scheme has limited support in UWP due to the strict `}<a parentName="td" {...{
              "href": "https://learn.microsoft.com/en-us/windows/uwp/files/file-access-permissions"
            }}>{`File access permissions`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.type]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Symbol`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`types.file`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`indicates which kind of entry to create. Pass types.folder to create a new folder. Note that if the type is file then this method just create"s" a file entry object and not the actual file on the disk. File on the storage is created when data is written into the file. eg: call write method on the file entry object.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.overwrite]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`if true, the create attempt can overwrite an existing file`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const newImgFolder = await fs.createEntryWithUrl("plugin-temp:/img", { type: types.folder });
const newTmpFolder = await fs.createEntryWithUrl("file:/Users/user/Documents/tmp", { type: types.folder });
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const newDatFile = await fs.createEntryWithUrl("plugin-temp:/tmp/test.dat", { overwrite: true });
const newTxtFile = await fs.createEntryWithUrl("file:/Users/user/Documents/test.txt", { overwrite: true });
`}</code></pre>
    <a name="module-storage-filesystemprovider-getentrywithurl" id="module-storage-filesystemprovider-getentrywithurl"></a>
    <h2 {...{
      "id": "getentrywithurlurl"
    }}>{`getEntryWithUrl(url)`}</h2>
    <p>{`Gets an entry of the given url and returns the appropriate instance.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<File|Folder>`}</inlineCode>{` the File or Folder object for the given url`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if invalid file url format or value is passed.
if the file/folder does not exist at the url.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the url to get an Entry object Note that file: scheme has limited support in UWP due to the strict `}<a parentName="td" {...{
              "href": "https://learn.microsoft.com/en-us/windows/uwp/files/file-access-permissions"
            }}>{`File access permissions`}</a></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const tmpFolder = await fs.getEntryWithUrl("plugin-temp:/tmp");
const docFolder = await fs.getEntryWithUrl("file:/Users/user/Documents");
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const tmpFile = await fs.getEntryWithUrl("plugin-temp:/tmp/test.dat");
const docFile = await fs.getEntryWithUrl("file:/Users/user/Documents/test.txt");
`}</code></pre>
    <a name="module-storage-filesystemprovider-getfsurl" id="module-storage-filesystemprovider-getfsurl"></a>
    <h2 {...{
      "id": "getfsurlentry"
    }}>{`getFsUrl(entry)`}</h2>
    <p>{`Returns the fs url of given entry.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Entry`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="module-storage-filesystemprovider-getnativepath" id="module-storage-filesystemprovider-getnativepath"></a>
    <h2 {...{
      "id": "getnativepathentry"
    }}>{`getNativePath(entry)`}</h2>
    <p>{`Returns the platform native file system path of given entry.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Entry`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="module-storage-filesystemprovider-createsessiontoken" id="module-storage-filesystemprovider-createsessiontoken"></a>
    <h2 {...{
      "id": "createsessiontokenentry"
    }}>{`createSessionToken(entry)`}</h2>
    <p>{`Returns a token suitable for use with certain host-specific APIs (such as Photoshop). This token is valid only for the current plugin session. As such, it is of no use if you serialize the token to persistent storage, as the token will be invalid in the future.`}</p>
    <p>{`Note: When using the Photoshop DOM API, pass the instance of the file instead of a session token -- Photoshop will convert the entry into a session token automatically on your behalf.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the session token for the given entry  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Entry`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const fs = require('uxp').storage.localFileSystem;
let entry = await fs.getFileForOpening();
let token = fs.createSessionToken(entry);
let result = await require('photoshop').action.batchPlay([{
    _obj: "open",
    "target": {
       _path: token, // Rather than a system path, this expects a session token
        _kind: "local",
    }
}], {});
`}</code></pre>
    <a name="module-storage-filesystemprovider-getentryforsessiontoken" id="module-storage-filesystemprovider-getentryforsessiontoken"></a>
    <h2 {...{
      "id": "getentryforsessiontokentoken"
    }}>{`getEntryForSessionToken(token)`}</h2>
    <p>{`Returns the file system Entry that corresponds to the session token obtained from `}<inlineCode parentName="p">{`createSessionToken`}</inlineCode>{`. If an entry cannot be found that matches the token, then a `}<inlineCode parentName="p">{`Reference Error: token is not defined`}</inlineCode>{` error is thrown.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Entry`}</inlineCode>{` - the corresponding entry for the session token  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`token`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="module-storage-filesystemprovider-createpersistenttoken" id="module-storage-filesystemprovider-createpersistenttoken"></a>
    <h2 {...{
      "id": "createpersistenttokenentry"
    }}>{`createPersistentToken(entry)`}</h2>
    <p>{`Returns a token suitable for use with host-specific APIs (such as Photoshop), or for storing a persistent reference to an entry (useful if you want to only ask for permission to access a file or folder once). A persistent token is not guaranteed to last forever -- certain scenarios can cause the token to longer work (including moving files, changing permissions, or OS-specific limitations). If a persistent token cannot be reused, you'll get an error at the time of use.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<string>`}</inlineCode>{` - the persistent token for the given entry  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Entry`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const fs = require('uxp').storage.localFileSystem;
let entry = await fs.getFileForOpening();
let token = await fs.createPersistentToken(entry);
localStorage.setItem("persistent-file", token);
`}</code></pre>
    <a name="module-storage-filesystemprovider-getentryforpersistenttoken" id="module-storage-filesystemprovider-getentryforpersistenttoken"></a>
    <h2 {...{
      "id": "getentryforpersistenttokentoken"
    }}>{`getEntryForPersistentToken(token)`}</h2>
    <p>{`Returns the file system Entry that corresponds to the persistent token obtained from `}<inlineCode parentName="p">{`createPersistentToken`}</inlineCode>{`. If an entry cannot be found that matches the token, then a `}<inlineCode parentName="p">{`Reference Error: token is not defined`}</inlineCode>{` error is thrown.`}</p>
    <p>{`Note: retrieving an entry for a persistent token does `}<em parentName="p">{`not`}</em>{` guarantee that the entry is valid for use. You'll need to properly handle the case where the entry no longer exists on the disk, or the permissions have changed by catching the appropriate errors. If that occurs, the suggested practice is to prompt the user for the entry again and store the new token.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Entry>`}</inlineCode>{` - the corresponding entry for the persistent token  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`token`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const fs = require('uxp').storage.localFileSystem;
let entry, contents, tries = 3, success = false;
while (tries > 0) {
    try {
        entry = await fs.getEntryForPersistentToken(localStorage.getItem("persistent-file"));
        contents = await entry.read();
        tries = 0;
        success = true;
    } catch (err) {
        entry = await fs.getFileForOpening();
        localStorage.setItem("persistent-token", await fs.createPersistentToken(entry));
        tries--;
    }
}
if (!success) {
    // fail gracefully somehow
}
`}</code></pre>
    <a name="module-storage-filesystemprovider-isfilesystemprovider" id="module-storage-filesystemprovider-isfilesystemprovider"></a>
    <h2 {...{
      "id": "isfilesystemproviderfs"
    }}>{`isFileSystemProvider(fs)`}</h2>
    <p>{`Checks if the supplied object is a `}<inlineCode parentName="p">{`FileSystemProvider`}</inlineCode>{`. It's safe to use even
if the object is `}<inlineCode parentName="p">{`null`}</inlineCode>{` or `}<inlineCode parentName="p">{`undefined`}</inlineCode>{`. Useful for type checking.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - If `}<inlineCode parentName="p">{`true`}</inlineCode>{`, the object is a file system provider  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the object to check`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      